import { GcTableRow } from '@ip-only/front-end-library';
import {
  DeliveryPointsItem,
  GroupAgreementSections,
  Item,
  SectionStatus,
} from '../entities/installation-reporting-mdu.entities';
import { getDeliveryPointDeliveryStatus } from './delivery-status.helper';

const sectionOrFallback = (
  sectionStatuses: Item['sectionStatuses'],
  ...keys: string[]
): SectionStatus | null | undefined => {
  for (const key of keys) {
    const value = sectionStatuses?.[key];
    if (value) {
      return value;
    }
  }
  return undefined;
};

function buildTableRowBuilding(item: Item): GcTableRow {
  const sections = GroupAgreementSections;
  return {
    name: item.name,
    status: item.deliveryStatus ?? '',
    buildingId: item.id,
    plotDesign: sectionOrFallback(item.sectionStatuses, sections.PLOT_DESIGN),
    preinstallation: sectionOrFallback(
      item.sectionStatuses,
      sections.PRE_INSTALLATION,
    ),
    plotExcavation: sectionOrFallback(
      item.sectionStatuses,
      sections.PLOT_EXCAVATION,
    ),
    ductConnection: sectionOrFallback(
      item.sectionStatuses,
      sections.DUCT_CONNECTING,
    ),
    cableBlowing: sectionOrFallback(
      item.sectionStatuses,
      sections.CABLE_BLOWING,
    ),
    splicingMeasuring: sectionOrFallback(
      item.sectionStatuses,
      sections.SPLICING_MEASURING,
    ),
    commissioning: sectionOrFallback(item.sectionStatuses, sections.COMMISSION),
  };
}

function buildTableRowDeliveryPoint(item: DeliveryPointsItem): GcTableRow {
  const sections = GroupAgreementSections;
  return {
    address: item.address,
    status: getDeliveryPointDeliveryStatus(item),
    buildingId: item.buildingId ?? '',
    deliveryPointId: item.id,
    macNetAdminId: item.installationInformation,
    installationDate: item.installationDate,
    preinstallation: sectionOrFallback(
      item.sectionStatuses,
      sections.PRE_INSTALLATION,
    ),
    splicingMeasuring: sectionOrFallback(
      item.sectionStatuses,
      sections.SPLICING_MEASURING,
    ),
    commissioning: sectionOrFallback(item.sectionStatuses, sections.COMMISSION),
  };
}

export function mapBuildingTableRows(items: Item[]): GcTableRow[] {
  return items.map(buildTableRowBuilding);
}

export function mapDeliveryPointTableRows(
  items: DeliveryPointsItem[],
): GcTableRow[] {
  return items.map(buildTableRowDeliveryPoint);
}

const valueMatchesSearchQuery = (value: unknown, query: string): boolean => {
  if (value === null || value === undefined) {
    return false;
  }
  if (typeof value === 'object') {
    return Object.values(value as Record<string, unknown>).some((nested) =>
      valueMatchesSearchQuery(nested, query),
    );
  }
  return String(value).toLowerCase().includes(query);
};

export function filterTableRowsBySearch(
  rows: GcTableRow[],
  searchQuery: string,
): GcTableRow[] {
  const query = searchQuery.trim().toLowerCase();
  if (!query) {
    return rows;
  }
  return rows.filter((row) =>
    Object.values(row).some((value) => valueMatchesSearchQuery(value, query)),
  );
}
